import { getTenantId } from 'common/helpers/apiHelper';

const FrenchConnectionMessage = () => {
  if (getTenantId() !== 'french-connection-wines') {
    return null;
  }

  return (
    <>
      <br />
      <br />
      If customizing, you will need to hit UPDATE below each bottle count as you
      go. The quantity available for the final item in the cart will adjust
      accordingly.
    </>
  );
};

export default FrenchConnectionMessage;
